import React from 'react';
import clsx from 'clsx';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import { useWallet } from '@solana/wallet-adapter-react';
import { shortenAddress } from '@utils/shorten';
import { Button } from '@components/Button';
import { useSolUserContext } from '@providers/SolUserProvider';

// Default styles that can be overridden by your app
// We override styles in globals.css
require('@solana/wallet-adapter-react-ui/styles.css');

export const SolanaConnect = (props: { full?: boolean }) => {
  const { wallet } = useWallet();
  const { onClickedConnect } = useSolUserContext();

  return (
    <WalletMultiButton
      className={clsx('solana-custom-button-purple', props.full && 'w-full')}
      onClick={() => {
        onClickedConnect();
      }}
    >
      {wallet ? <>{shortenAddress(wallet.adapter.publicKey?.toString())}</> : <>Connect Solana</>}
    </WalletMultiButton>
  );
};

export const SolanaSignIn = (props: { full?: boolean }) => {
  const { signIn, isSigningLoginMessage } = useSolUserContext();

  return (
    <Button
      color="purple"
      onClick={signIn}
      disabled={isSigningLoginMessage}
      loading={isSigningLoginMessage}
      full={props.full}
    >
      Sign in with Solana
    </Button>
  );
};
